module.exports = __webpack_public_path__ + "img/B-791-800.ca681e5f.svg";